import { cn } from '@/lib/utils';

/**
 * Official TimeGlobe brand mark — the same asset as the sidebar/header logo.
 * It is the assistant's identity: avatar in the chat, send button, mode switch.
 */
export const AI_LOGO_SRC = `${process.env.PUBLIC_URL}/images/timeglobe.svg`;

export function AiLogo({ className }: { className?: string }) {
  return <img src={AI_LOGO_SRC} alt="" aria-hidden className={cn('object-contain', className)} />;
}

export default AiLogo;
